import { get } from 'lodash'

export const ERROR_MESSAGES = {
	BranchNameAlreadyExists: 'Bunday nomli filial allaqachon mavjud',
	InstallmentSettingAlreadyExists:
		'Bu filialda bunday muddat allaqachon sozlangan',
	InvalidBranchDetails: 'Filial nomini kiriting',
	InvalidInstallmentSetting:
		"Oylar soni 1–60, foiz 0–500 oralig'ida bo'lishi kerak",
	BranchNotFound: "Filial topilmadi — ro'yxat yangilandi",
	InstallmentSettingNotFound: "Sozlama topilmadi — ro'yxat yangilandi",
}

export const FORBIDDEN_MESSAGE = "Bu amal uchun ruxsatingiz yo'q"
export const SERVER_ERROR_MESSAGE = "Server xatosi, keyinroq urinib ko'ring"
export const NETWORK_ERROR_MESSAGE =
	"Server bilan aloqa yo'q, internetni tekshiring"

export const getErrorStatus = (err) => get(err, 'response.status', 0)
export const getErrorCode = (err) => get(err, 'response.data.code', '')

export const getErrorMessage = (err) => {
	const status = getErrorStatus(err)
	const code = getErrorCode(err)

	if (code && ERROR_MESSAGES[code]) return ERROR_MESSAGES[code]
	if (status === 403) return FORBIDDEN_MESSAGE
	if (status >= 500) return SERVER_ERROR_MESSAGE
	if (!status) return NETWORK_ERROR_MESSAGE
	return SERVER_ERROR_MESSAGE
}

export const isNotFound = (err) => getErrorStatus(err) === 404
export const isConflict = (err) => getErrorStatus(err) === 409
export const isUnauthorized = (err) => getErrorStatus(err) === 401
